import { KanavaApiException } from "../client/error";

export function isExpiredSessionError(error: any) {
	return error instanceof KanavaApiException && error.statusCode === 401;
}
